module.exports = __webpack_public_path__ + "img/vox.0b74679e.png";